// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2bNiG","title":"ClientInsurance_title__27yNc","itemText":"ClientInsurance_itemText__1Pn1C"};